import styles from './index.less';
import { FC, useEffect, useState } from 'react';
import { Steps } from 'react-vant';


// dispatch 待派单, accept 待接单,pending 待处理, progress 处理中,completed 已完成,canceled 已撤回
const ticketStatusObj: Record<string, string> = {
  dispatch: '待派单',
  accept: '待接单',
  pending: '待处理',
  progress: '处理中',
  completed: '已完成',
  canceled: '已撤回',
  back: '已退回',
  null: '',
};

interface RepairStepsProps {
  status?: string;
  flowList: Array<any>;
}
const RepairSteps: FC<RepairStepsProps> = (props) => {
  const { flowList } = props;
  const [list, setList] = useState<Array<any>>([]);

  useEffect(() => {
    if (flowList) {
      console.log('流转记录', flowList);
      setList(flowList || []);
    }
  }, [flowList]);

  return (
    <div className={styles.container}>
       <Steps direction="vertical" active={0}>
          {list.map((item) => (
            <Steps.Item key={item.sequenceNbr}>
              <h3>
                {item.createBy}: {item.operationName}
              </h3>
              <p>当前状态：{item.afterStatusName}</p>
              <p>{item.createTime}</p>
              <p>{item.operationDesc}</p>
            </Steps.Item>
          ))}
        </Steps>
    </div>
  );
};

export default RepairSteps;
